import { render, staticRenderFns } from "./PowerOfAttorney.vue?vue&type=template&id=066dbbbe"
import script from "./PowerOfAttorney.vue?vue&type=script&lang=js"
export * from "./PowerOfAttorney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports